import { useReducer } from "react";
import { sendResetPasswordLink } from "./resetPassword.services";

const RESET_PASSWORD_ACTIONS = {
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
  RESET: "reset",
};

const initialState = {
  loading: false,
  error: null,
  success: null,
};

const resetPasswordRequestReducer = (state, action) => {
  switch (action.type) {
    case RESET_PASSWORD_ACTIONS.LOADING:
      return {
        ...state,
        loading: action.payload,
        success: null,
        error: null,
      };
    case RESET_PASSWORD_ACTIONS.ERROR:
      return {
        ...state,
        error: action.payload,
        success: null,
        loading: false,
      };
    case RESET_PASSWORD_ACTIONS.SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        success: action.payload,
      };
    case RESET_PASSWORD_ACTIONS.RESET:
      return {
        ...state,
        error: null,
        loading: false,
        success: null,
      };
    default:
      return { ...state };
  }
};

const createResetPasswordActions = (dispatch) => ({
  resetPassword: async (userId) => {
    dispatch({
      type: RESET_PASSWORD_ACTIONS.LOADING,
      payload: true,
    });
    try {
      const response = await sendResetPasswordLink(userId);
      if (response?.error) {
        dispatch({
          type: RESET_PASSWORD_ACTIONS.ERROR,
          payload:
            response.error ??
            "We couldn't send the reset password link. Please try again.",
        });
      } else {
        dispatch({
          type: RESET_PASSWORD_ACTIONS.SUCCESS,
          payload: true,
        });
      }
    } catch (error) {
      dispatch({
        type: RESET_PASSWORD_ACTIONS.ERROR,
        payload:
          error?.message ??
          "We couldn't send the reset password link. Please try again.",
      });
    }
  },
  reset: () => {
    dispatch({
      type: RESET_PASSWORD_ACTIONS.RESET,
      payload: true,
    });
  },
});

export const useResetPasswordRequest = () => {
  const [state, dispatch] = useReducer(resetPasswordRequestReducer, initialState);
  const actions = createResetPasswordActions(dispatch);

  return { state, actions };
};
